<template>
    <section class="card-section">
        <div class="toolbar no-print">
            <button class="btn btn-primary" @click="imprimirLaudo">Imprimir / Gerar PDF</button>
        </div>

        <div class="laudo-print" ref="printRef">
            <header class="laudo-header">
                <div class="logo-box">
                    <div class="logo-placeholder">LOGO</div>
                </div>

                <div class="titulo-box">
                    <div class="versao">versão 2.0</div>
                    <h1>PLA 00 – LAUDO DE INSPEÇÃO SANITÁRIA ANUAL</h1>
                    <div class="numero-laudo">Nº {{ cabecalho.numeroLaudo || '-' }}</div>
                </div>
            </header>

            <section class="bloco">
                <div class="bloco-titulo">INFORMAÇÕES SOBRE O ESTABELECIMENTO</div>

                <div class="subtitulo">IDENTIFICAÇÃO DO ESTABELECIMENTO</div>

                <div class="grid-info cols-2">
                    <div><strong>Razão social:</strong> {{ cabecalho.razaoSocial || '-' }}</div>
                    <div><strong>Nome fantasia:</strong> {{ cabecalho.nomeFantasia || '-' }}</div>
                    <div><strong>Número de registro no SIM-POA:</strong> {{ cabecalho.numeroRegistroSim || '-' }}</div>
                    <div><strong>Inscrição estadual:</strong> {{ cabecalho.inscricaoEstadual || '-' }}</div>
                    <div><strong>CNPJ/CPF:</strong> {{ cabecalho.cnpjCpf || '-' }}</div>
                    <div><strong>Telefone:</strong> {{ cabecalho.telefone || '-' }}</div>
                    <div><strong>Endereço:</strong> {{ cabecalho.endereco || '-' }}</div>
                    <div><strong>Bairro:</strong> {{ cabecalho.bairro || '-' }}</div>
                    <div><strong>Município:</strong> {{ cabecalho.municipio || '-' }}</div>
                    <div><strong>CEP / UF:</strong> {{ cabecalho.cep || '-' }} / {{ cabecalho.uf || '-' }}</div>
                    <div><strong>E-mail:</strong> {{ cabecalho.email || '-' }}</div>
                    <div><strong>Data da inspeção:</strong> {{ formatarData(cabecalho.dataInspecao) }}</div>
                </div>

                <div class="subtitulo">ATIVIDADE / CLASSIFICAÇÃO</div>
                <div class="grid-info cols-2">
                    <div><strong>Classificação do estabelecimento:</strong> {{ cabecalho.classificacaoEstabelecimento || '-' }}</div>
                    <div><strong>Nº de turnos:</strong> {{ cabecalho.numeroTurnos || 0 }}</div>
                    <div><strong>Responsável técnico:</strong> {{ cabecalho.nomeResponsavelTecnico || '-' }}</div>
                    <div><strong>Formação acadêmica:</strong> {{ cabecalho.formacaoAcademica || '-' }}</div>
                    <div><strong>Nº de pessoas na atividade:</strong> {{ cabecalho.numeroPessoasAtividade || 0 }}</div>
                    <div><strong>Possui RT:</strong> {{ cabecalho.possuiResponsavelTecnico === 'S' ? 'Sim' : 'Não' }}</div>
                </div>

                <div class="subtitulo">RESPONSÁVEL POR ACOMPANHAR A INSPEÇÃO</div>
                <div class="grid-info cols-3">
                    <div><strong>Nome:</strong> {{ cabecalho.nomeAcompanhante || '-' }}</div>
                    <div><strong>CPF:</strong> {{ cabecalho.cpfAcompanhante || '-' }}</div>
                    <div><strong>Função:</strong> {{ cabecalho.funcaoAcompanhante || '-' }}</div>
                </div>

                <div class="subtitulo">MOTIVO DA INSPEÇÃO</div>
                <div>
                    {{ cabecalho.motivoInspecao === 'OUTROS'
                        ? `Outros: ${cabecalho.motivoOutros || '-'}`
                        : (cabecalho.motivoInspecao || '-') }}
                </div>
            </section>

            <section class="bloco">
                <div class="bloco-titulo">AVALIAÇÃO DO ESTABELECIMENTO</div>

                <div
                    v-for="secao in secoes"
                    :key="secao.codigo"
                    class="secao-print"
                >
                    <div class="secao-print-title">
                        {{ secao.codigo }}. {{ secao.titulo }}
                    </div>

                    <div
                        v-for="subgrupo in secao.subgrupos"
                        :key="subgrupo.codigo"
                        class="subgrupo-print"
                    >
                        <table class="laudo-table">
                            <thead>
                                <tr>
                                    <th colspan="2" class="th-left">
                                        {{ subgrupo.codigo }}. {{ subgrupo.titulo }}
                                    </th>
                                    <th>C</th>
                                    <th>CR</th>
                                    <th>NC</th>
                                    <th>NA</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="item in subgrupo.itens"
                                    :key="item.codigo"
                                >
                                    <td class="col-codigo">{{ item.codigo }}</td>
                                    <td class="col-descricao">
                                        <div>{{ item.descricao }}</div>
                                        <div
                                            v-if="itens[item.codigo]?.observacao"
                                            class="obs-item"
                                        >
                                            <strong>Obs.:</strong> {{ itens[item.codigo]?.observacao }}
                                        </div>
                                    </td>
                                    <td class="center">{{ marcar(itens[item.codigo]?.situacao, 'C') }}</td>
                                    <td class="center">{{ marcar(itens[item.codigo]?.situacao, 'CR') }}</td>
                                    <td class="center">{{ marcar(itens[item.codigo]?.situacao, 'NC') }}</td>
                                    <td class="center">{{ marcar(itens[item.codigo]?.situacao, 'NA') }}</td>
                                </tr>
                            </tbody>
                        </table>

                        <div class="observacao-subgrupo">
                            <strong>Observações:</strong>
                            {{ observacoes[subgrupo.codigo] || '---' }}
                        </div>
                    </div>
                </div>
            </section>

            <section class="bloco">
                <div class="bloco-titulo">FINALIZAÇÃO / RELATÓRIO</div>

                <div class="subtitulo">DISPOSIÇÃO</div>
                <p class="texto-livre">
                    {{ finalizacao.disposicao || '-' }}
                </p>

                <div class="subtitulo">CLASSIFICAÇÃO DO ESTABELECIMENTO</div>

                <div class="classificacao-box">
                    <div><strong>Total de itens que não se aplicam / não avaliados (NA):</strong> {{ totais.naoAplicavel }}</div>
                    <div><strong>Itens utilizáveis:</strong> {{ totais.itensUtilizaveis }}</div>
                    <div><strong>Total de itens conformes:</strong> {{ totais.conforme }}</div>
                    <div><strong>Percentual de conformidade:</strong> {{ totais.percentualConformidade }}%</div>
                    <div><strong>Classificação sugerida:</strong> {{ totais.grupo }}</div>
                </div>

                <div class="grupo-checks">
                    <div>[{{ totais.grupo === 'GRUPO 01' ? 'X' : ' ' }}] GRUPO 01 - 85 a 100%</div>
                    <div>[{{ totais.grupo === 'GRUPO 02' ? 'X' : ' ' }}] GRUPO 02 - 61 a 84,99%</div>
                    <div>[{{ totais.grupo === 'GRUPO 03' ? 'X' : ' ' }}] GRUPO 03 - 0 a 60,99%</div>
                </div>

                <div class="subtitulo">CONCLUSÃO FISCAL</div>
                <p class="texto-livre">
                    {{ finalizacao.conclusaoFiscal || 'Sem observações complementares.' }}
                </p>

                <div class="assinaturas-grid">
                    <div class="assinatura-box">
                        <div class="assinatura-linha"></div>
                        <div class="assinatura-nome">{{ finalizacao.nomeResponsavelInspecao1 || 'Nome do responsável ou carimbo' }}</div>
                        <div class="assinatura-legenda">Responsável pela inspeção</div>
                        <div class="assinatura-extra">Matrícula: {{ finalizacao.matriculaResponsavelInspecao1 || '-' }}</div>
                    </div>

                    <div class="assinatura-box">
                        <div class="assinatura-linha"></div>
                        <div class="assinatura-nome">{{ finalizacao.nomeResponsavelInspecao2 || 'Nome do responsável ou carimbo' }}</div>
                        <div class="assinatura-legenda">Responsável pela inspeção</div>
                        <div class="assinatura-extra">Matrícula: {{ finalizacao.matriculaResponsavelInspecao2 || '-' }}</div>
                    </div>
                </div>

                <div class="assinaturas-grid single">
                    <div class="assinatura-box">
                        <div class="assinatura-linha"></div>
                        <div class="assinatura-nome">{{ finalizacao.nomeResponsavelEmpresa || 'Nome do responsável ou carimbo' }}</div>
                        <div class="assinatura-legenda">Responsável pela empresa</div>
                    </div>

                    <div class="assinatura-box">
                        <div class="assinatura-linha"></div>
                        <div class="assinatura-nome">{{ finalizacao.nomeTestemunha || 'Nome do responsável ou carimbo' }}</div>
                        <div class="assinatura-legenda">Testemunha</div>
                    </div>
                </div>

                <div class="rodape-data">
                    {{ finalizacao.cidadeAssinatura || cabecalho.municipio || '______________________/SC' }},
                    {{ formatarDataExtenso(finalizacao.dataAssinatura) }}
                </div>
            </section>
        </div>
    </section>
</template>

<script setup>
import { ref } from 'vue'

defineProps({
    cabecalho: { type: Object, required: true },
    itens: { type: Object, required: true },
    observacoes: { type: Object, required: true },
    finalizacao: { type: Object, required: true },
    totais: { type: Object, required: true },
    secoes: { type: Array, required: true },
})

const printRef = ref(null)

function marcar(valor, alvo) {
    return valor === alvo ? 'X' : ''
}

function formatarData(valor) {
    if (!valor) return '-'
    const [ano, mes, dia] = valor.split('-')
    if (!ano || !mes || !dia) return valor
    return `${dia}/${mes}/${ano}`
}

function formatarDataExtenso(valor) {
    if (!valor) return '______/______/__________'
    const [ano, mes, dia] = valor.split('-')
    if (!ano || !mes || !dia) return valor
    return `${dia}/${mes}/${ano}`
}

function imprimirLaudo() {
    window.print()
}
</script>

<style scoped>
.card-section {
    background: #fff;
    border: 1px solid #d8dee8;
    border-radius: 12px;
    padding: 16px;
}

.toolbar {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 14px;
}

.btn {
    border: none;
    border-radius: 8px;
    padding: 10px 14px;
    font-weight: 600;
    cursor: pointer;
}

.btn-primary {
    background: #2563eb;
    color: white;
}

.laudo-print {
    background: #fff;
    color: #111827;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 12px;
}

.laudo-header {
    display: grid;
    grid-template-columns: 110px 1fr;
    gap: 16px;
    align-items: center;
    border: 1px solid #000;
    padding: 12px;
}

.logo-box {
    display: flex;
    justify-content: center;
    align-items: center;
}

.logo-placeholder {
    width: 80px;
    height: 80px;
    border: 1px solid #000;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight: 700;
}

.titulo-box {
    text-align: center;
}

.versao {
    font-size: 11px;
    margin-bottom: 4px;
}

.titulo-box h1 {
    margin: 0;
    font-size: 18px;
    text-transform: uppercase;
}

.numero-laudo {
    margin-top: 6px;
    font-weight: 700;
}

.bloco {
    margin-top: 14px;
    border: 1px solid #000;
}

.bloco-titulo {
    background: #e5e7eb;
    padding: 8px 10px;
    font-weight: 700;
    text-transform: uppercase;
    border-bottom: 1px solid #000;
}

.subtitulo {
    margin: 10px 10px 6px;
    font-weight: 700;
    text-transform: uppercase;
}

.grid-info {
    display: grid;
    gap: 8px 16px;
    padding: 0 10px 10px;
}

.cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
}

.cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
}

.secao-print {
    margin: 10px;
}

.secao-print-title {
    padding: 8px 10px;
    background: #f3f4f6;
    border: 1px solid #000;
    border-bottom: none;
    font-weight: 700;
    text-transform: uppercase;
}

.subgrupo-print + .subgrupo-print {
    margin-top: 10px;
}

.laudo-table {
    width: 100%;
    border-collapse: collapse;
}

.laudo-table th,
.laudo-table td {
    border: 1px solid #000;
    padding: 6px;
    vertical-align: top;
}

.laudo-table th {
    background: #f9fafb;
}

.th-left {
    text-align: left;
}

.col-codigo {
    width: 80px;
    white-space: nowrap;
}

.col-descricao {
    width: auto;
}

.center {
    width: 50px;
    text-align: center;
    font-weight: 700;
}

.obs-item {
    margin-top: 4px;
    font-size: 11px;
    color: #374151;
}

.observacao-subgrupo {
    border: 1px solid #000;
    border-top: none;
    padding: 8px;
    margin-bottom: 8px;
    min-height: 28px;
}

.texto-livre {
    margin: 0;
    padding: 0 10px 10px;
    line-height: 1.5;
    text-align: justify;
}

.classificacao-box {
    display: grid;
    gap: 6px;
    padding: 0 10px 10px;
}

.grupo-checks {
    display: grid;
    gap: 4px;
    padding: 0 10px 10px;
}

.assinaturas-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 26px;
    padding: 20px 10px 10px;
}

.assinaturas-grid.single {
    margin-top: 10px;
}

.assinatura-box {
    min-height: 90px;
}

.assinatura-linha {
    border-bottom: 1px solid #000;
    margin-bottom: 8px;
    height: 34px;
}

.assinatura-nome {
    font-weight: 700;
}

.assinatura-legenda,
.assinatura-extra {
    margin-top: 4px;
}

.rodape-data {
    padding: 10px;
    text-align: right;
}

@media print {
    .no-print {
        display: none !important;
    }

    .card-section {
        border: none;
        padding: 0;
    }

    .laudo-print {
        font-size: 11px;
    }

    .bloco,
    .laudo-header,
    .secao-print-title,
    .laudo-table th,
    .laudo-table td,
    .observacao-subgrupo {
        break-inside: avoid;
        page-break-inside: avoid;
    }
}
</style>